<div [ngSwitch]="errorCode" style="padding: 0 16px">
	<ng-container *ngSwitchCase="'beta'">
		<img alt="illustration" src="assets/128.svg" class="illustration" loading="lazy" />
		<div class="mat-title mat-accent-gradient">Fonctionnalité inaccessible en Test !</div>
		<p class="mat-grey">
			Il n'est pas possible d'accéder à cette fonctionnalité depuis l'environnement de test !
			<br />Si vous pensez qu'il s'agit d'une erreur avertissez le service informatique.
		</p>
	</ng-container>

	<ng-container *ngSwitchCase="403">
		<img alt="illustration" src="assets/128.svg" class="illustration" loading="lazy" />
		<div class="mat-title mat-accent-gradient">Interdit !</div>
		<p class="mat-grey">
			Vous tentez d'accéder à une page qui ne vous est pas autorisée !
			<br />Si vous pensez qu'il s'agit d'une erreur avertissez le service informatique.
		</p>
	</ng-container>

	<ng-container *ngSwitchCase="404">
		<img alt="illustration" src="assets/458.svg" class="illustration" loading="lazy" />
		<div class="mat-title mat-accent-gradient">Oups !</div>
		<p class="mat-grey">
			La page que vous demandez n'existe pas ou n'a pas pu être trouvée !
			<br />Essayez d'utiliser le moteur de recherche dans le menu principal.
		</p>
		<mat-list>
			<div mat-subheader class="mat-accent-gradient">
				Si vous avez utilisé un raccourci (sur le bureau ou dans le navigateur), suivez la procédure suivante
			</div>
			<mat-list-item class="mat-grey">1. Cliquez sur le logo OXANCE</mat-list-item>
			<mat-list-item class="mat-grey">2. Supprimez votre raccourci</mat-list-item>
			<mat-list-item class="mat-grey">3. Recréez votre raccourci</mat-list-item>
		</mat-list>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<img alt="illustration" src="assets/304.svg" class="illustration" loading="lazy" />
		<div class="mat-title mat-accent-gradient">Erreur non gérée !</div>
		<p class="mat-grey">
			Une erreur interne est survenue et empêche la requête de se terminer 
			<br />le service informatique en à été informé.
		</p>
	</ng-container>
</div>